import ChatSocket from '@/socket/ChatSocket';
import KnowledgeChatSocket from '@/socket/KnowledgeChatSocket';
import PromptTemplateChatSocket from '@/socket/PromptTemplateChatSocket';

/**
 * Socket Mixin
 */
export default {
    data () {
        return { socket: null };
    },
    beforeDestroy () {
        if (this.socket) {
            this.socket.$off('message');
            this.socket.$off('close');
            this.socket.$off('error');
            this.socket.$off('connected');
        }
        this.closeSocket(); // 页面切走前关闭socket
    },
    methods: {
        /**
         * 初始化socket（根据sessionId）
         */
        initSocket (sessionId) {
            // 初始化socket（根据sessionId）
            this.closeSocket();

            // let ChatSocketClass = ChatSocket;
            // if (this.currentKnowledge) { // 知识库问答的socket类
            //     ChatSocketClass = KnowledgeChatSocket;
            // } else if (this.currentTemplate) { // 提示词问答的socket类
            //     ChatSocketClass = PromptTemplateChatSocket;
            // }
            let ChatSocketClass = '';
            if (this.currentKnowledge) { // 知识库问答的socket类
                ChatSocketClass = KnowledgeChatSocket;
            } else {
                return;
            }

            sessionId = sessionId || this.currentSessionId;

            this.ui.isSocketReconnecting = true; // 会话重连等待

            this.socket = new ChatSocketClass({ sessionId });

            // 心跳
            let heartbeatTimeoutObj = null;
            let heartbeat = () => {
                heartbeatTimeoutObj = setTimeout(() => {
                    if (this.socket && this.socket.connected) {
                        if (this.ui.typing) {
                            // 打字时跳过发送心跳
                            heartbeat(); // 下一次心跳
                        } else {
                            this.socket.send('ping'); // 发送心跳
                            heartbeat(); // 下一次心跳
                        }
                    }
                }, 30000);
            };
            heartbeat(); // 启动心跳

            let reconnectIntervalObj = null;
            // 断线2秒后重连
            this.socket.$on('close', () => {
                this.ui.typing = false; // 停止打字
                clearTimeout(heartbeatTimeoutObj); // 清除心跳定时
                if (this.socket.sessionId === sessionId && this.isAutoReconnect) { // sessionId一致，才重连
                    if (!this.ui.isSocketReconnecting) {
                        this.ui.isSocketReconnecting = true; // 会话重连等待
                        clearInterval(reconnectIntervalObj);
                        reconnectIntervalObj = setInterval(() => {
                            if (this.socket && this.socket.connected) {
                                clearInterval(reconnectIntervalObj);
                                reconnectIntervalObj = null;
                                return;
                            }
                            console.warn('socket close, 自动重连');
                            this.initSocket(sessionId);
                        }, 2000);
                    }
                }
            });
            // 断线2秒后重连
            this.socket.$on('error', () => {
                this.ui.typing = false; // 停止打字
                clearTimeout(heartbeatTimeoutObj); // 清除心跳定时
                if (this.socket.sessionId === sessionId) { // sessionId一致，才重连
                    this.closeSocket();

                    if (!this.ui.isSocketReconnecting) {
                        this.ui.isSocketReconnecting = true; // 会话重连等待
                        clearInterval(reconnectIntervalObj);
                        reconnectIntervalObj = setInterval(() => {
                            if (this.socket && this.socket.connected) {
                                clearInterval(reconnectIntervalObj);
                                reconnectIntervalObj = null;
                                return;
                            }
                            console.warn('socket error, 自动重连');
                            this.initSocket(sessionId);
                        }, 2000);
                    }
                }
            });

            this.socket.$on('connected', (message) => {
                this.ui.isSocketReconnecting = false; // 会话重连结束
                clearInterval(reconnectIntervalObj);
                reconnectIntervalObj = null;
            });

            let typingTimeoutObj = null;
            this.socket.$on('message', (message) => {
                let answer = message;

                // 文字回答
                if (answer && answer.type === 'TEXT') {
                    let last = this.currentChat.messages[this.currentChat.messages.length - 1]; // 最后一条消息（回答，用于打字）
                    let lastAsk = this.currentChat.messages[this.currentChat.messages.length - 2]; // 倒数第二条消息（提问）
                    if (lastAsk && !lastAsk.questionTime && answer.time) lastAsk.questionTime = parseInt(answer.time) || Date.now(); // 设置提问时间

                    // 设置3秒超时，强制打字完成
                    clearTimeout(typingTimeoutObj);
                    typingTimeoutObj = setTimeout(async () => {
                        if (!this.ui.typing) return;

                        // 打字完成
                        this.ui.typing = false;
                        clearTimeout(typingTimeoutObj);
                        if (last && last.role === 'assistant') this.$set(last, 'finished', true);

                        if (this.mdTempStr.indexOf('```gpt-') === 0) {
                            // ```gpt-开头，加上```结尾
                            last.notShowContent = last.content = this.mdTempStr + '\n```';
                            this.mdTempStr = '';
                        }
                        this.saveContext();
                    }, 3000);

                    let str = answer.answer;
                    // str = str.replace(/�/g, '');
                    if (str === '[done]')str = '';

                    if (answer.status === 'FINISH') {
                        if (!this.ui.typing) return; // 已经打字完成，不再处理(一般是先timeout了)
                        // 打字完成
                        this.ui.typing = false;
                        clearTimeout(typingTimeoutObj);
                        if (last && last.role === 'assistant') this.$set(last, 'finished', true);

                        if (this.mdTempStr.indexOf('```gpt-') === 0) {
                            // ```gpt-开头，加上```结尾
                            last.notShowContent = last.content = this.mdTempStr + '\n```';
                            this.mdTempStr = '';
                        } else {
                            last.content += str;

                            if (!last.content) {
                                // 没有内容，显示默认回答
                                last.content = '服务器没有返回。';
                            }
                        }

                        this.saveContext();
                    } else {
                        let str = answer.answer;
                        // str = str.replace(/�/g, '');

                        // 打字
                        if (this.mdTempStr.indexOf('```gpt-') === 0) {
                            // 如果是```gpt-开头，则使用mdTempStr存储返回信息
                            this.mdTempStr += str;
                            last.notShowContent = this.mdTempStr;
                            last.content = '计算中，请稍候';
                            for (let i = 0; i < this.mdTempStr.length % 6; i++) {
                                last.content += ' .';
                            }
                        } else {
                            last.content += str;
                        }
                    }
                }
            });
        },

        /**
         * 关闭socket
         */
        closeSocket () {
            if (this.socket && this.socket.connected) this.socket.close();
        },

        /**
         * 重新连接socket
         */
        handleReconnectSocket ({ isSpecialSocket }) {
            if (isSpecialSocket) {
                // 断线调用平台的socket，连接各自的后端socket
                this.isAutoReconnect = false;
                this.closeSocket();
            } else {
                // 断线各自的后端socket，连接调用平台的后端socket
                this.isAutoReconnect = true;
                this.initSocket(this.currentSessionId);
            }
        }
    }
};
